import { render, staticRenderFns } from "./GDialog.vue?vue&type=template&id=d67b4968&scoped=true"
import script from "./GDialog.vue?vue&type=script&lang=js"
export * from "./GDialog.vue?vue&type=script&lang=js"
import style0 from "./GDialog.vue?vue&type=style&index=0&id=d67b4968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67b4968",
  null
  
)

export default component.exports